import bem from "easy-bem";
import React from "react";

import "./EditingPausedBanner.css";

const cn = bem("editing-paused-banner");

const EditingPausedBanner: React.FC = () => (
  <div
    className={cn()}
    role="status"
  >
    <span className={cn("icon")}>🛠</span>
    <span className={cn("text")}>
      Редактирование и комментирование контента временно приостановлено — идут
      технические работы
    </span>
  </div>
);

export default EditingPausedBanner;
